import { Injectable, Type, ComponentRef, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetailPageService {

  container: ViewContainerRef;
  container2: ViewContainerRef;

  setDetailContainer(container: ViewContainerRef) {
    this.container = container;
  }

  loadComponent<T>(component: Type<T>): ComponentRef<T>  {
    this.container.clear();
    return this.container.createComponent(component);
  }

  removeComponent() {
    this.container.clear();
  }

  setDetailContainer2(container: ViewContainerRef) {
    this.container2 = container;
  }

  loadComponent2<T>(component: Type<T>): ComponentRef<T>  {
    this.container2.clear();
    return this.container2.createComponent(component);
  }

  removeComponent2() {
    this.container2.clear();
  }
}
